import { inject, Injectable } from '@angular/core';
import { NgxAimService } from '../../../ngx-aim.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthnetConfig } from './authorizenet.model';

@Injectable({
  providedIn: 'root'
})
export class NgxAimAuthorizenetService {
  ngxAimService = inject(NgxAimService);
  http = inject(HttpClient);

  private baseUrl = `${this.ngxAimService.getApiUrl()}/payment/authorizenet`;

  getConfig(): Observable<AuthnetConfig> {
    return this.http.get<AuthnetConfig>(`${this.baseUrl}/config`);
  }
}
